import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';
import { FullSizeFlexBox } from '../../../../Components/FlexBox';
import { useAtomValue } from 'jotai';
import { themeAtom } from '../../../../Atoms';

const Summary = function Summary({ notes = null }) {
  const intl = useIntl();
  const currentTheme = useAtomValue(themeAtom);
  return (
    <>
      {notes ? (
        <FullSizeFlexBox
          sx={{
            padding: '16px',
            backgroundColor:
              currentTheme === 'dark' ? 'greys.darker' : '#ededed',
            color: '#111',
            borderRadius: '18px',
            flexGrow: 1,
          }}
        >
          <Box
            sx={{
              height: "100%",
              width: "100%",
              overflow: "auto"
            }}>
            <Typography variant="body1" style={{ whiteSpace: 'pre-wrap' }}>
              {notes}
            </Typography>
          </Box>
        </FullSizeFlexBox>
      ) : (
        <Typography variant="body1">{intl.messages.NO_NOTES}</Typography>
      )}
    </>
  );
};

Summary.propTypes = {
  notes: PropTypes.string,
};

export default Summary;
